<template>
	<div class="room-right">
		<div v-if="isShowGray === 1" class="room-right-con">
			<div class="switch">
				<div class="realTop_left">
					<div class="left_header">
						<span class="left_title">监测仪</span>
						<div style="position: relative; top:-2px" v-if="isReadonlyRole">
							<el-switch v-model="localSwitchStatus" :width="40" class="switch" active-color="#1890FF"
								inactive-color="#79b5f6" @change="emitSetStatus">
							</el-switch>
							<span v-if="localSwitchStatus" style="top:5px" class="switch-btn-open">开</span>
							<span v-else style="top:5px" class="switch-btn-off">关</span>
						</div>
						<div style="position: relative;" v-else class="left_title title-flex">
							<el-switch v-model="localSwitchStatus" :width="40" class="switch" active-color="#1890FF"
								inactive-color="#79b5f6" @change="emitSetStatus">
							</el-switch>
							<span v-if="localSwitchStatus" class="switch-btn-open">开</span>
							<span v-else class="switch-btn-off">关</span>
							<div class="title-flex-set" @click="$emit('set-toitet')">设置</div>
						</div>
					</div>
				</div>
			</div>
			<div class="room-icon">
				<div class="img_icon">
					<img src="./../../../assets/img/breath_gary.png" alt="" />
					<div>--</div>
				</div>
				<div class="img_icon">
					<img src="./../../../assets/img/heart_gary.png" alt="" />
					<div>--</div>
				</div>
			</div>
		</div>
		<div v-if="isShowGray === 2" class="room-right-con">
			<div class="switch">
				<div class="realTop_left">
					<div class="left_header">
						<span class="left_title">监测仪</span>
						<div style="position: relative;" v-if="isReadonlyRole">
							<el-switch v-model="localSwitchStatus" :width="40" class="switch" active-color="#1890FF"
								inactive-color="#79b5f6" @change="emitSetStatus">
							</el-switch>
							<span v-if="localSwitchStatus" class="switch-btn-open">开</span>
							<span v-else class="switch-btn-off">关</span>
						</div>
						<div style="position: relative;" v-else class="left_title title-flex">
							<el-switch v-model="localSwitchStatus" :width="40" class="switch" active-color="#1890FF"
								inactive-color="#79b5f6" @change="emitSetStatus">
							</el-switch>
							<span v-if="localSwitchStatus" class="switch-btn-open">开</span>
							<span v-else class="switch-btn-off">关</span>
							<div class="title-flex-set" @click="$emit('set-toitet')">设置</div>
						</div>
					</div>
				</div>
			</div>
			<div class="room-icon">
				<div class="room-icon-item">
					<div class="item-text item-lin" :class="{ 'metric-hidden': !showRealtimeMetric }">
						<p class="conter-low" :class="{ 'alarm-conter': isShowRedBreath == 1 }"></p>
						<p class="conter"></p>
						<p class="conter-height" :class="{ 'alarm-conter': isShowRedBreath == 3 }"></p>
						<div class="position-cirle" :class="{ 'alarm-conter': isShowRedBreath !== 2 }" :style="{
							left: breathPosition,
							background: isShowRedBreath !== 2 ? '#FF4D4F' : '#5CC726',
						}"></div>
					</div>
					<div class="item-text" :class="{ 'metric-hidden': !showRealtimeMetric }">
						<p :class="{ 'alarm-conter': isShowRedBreath == 1 }">偏低</p>
						<p :style="{
							color: isShowRedBreath == 2 ? '#5CC726' : '#262626',
						}">
							正常
						</p>
						<p :class="{ 'alarm-conter': isShowRedBreath == 3 }">偏高</p>
					</div>
					<div class="img_icon">
						<img v-if="isShowRedBreath == 2" src="./../../../assets/img/breath_blue.png" alt="" />
						<img v-else src="./../../../assets/img/breath_alarm@2x.png" alt="" />
						<div class="breath-text" :style="{ color: isShowRedBreath !== 2 ? '#FF4D4F' : '' }" translate="no">
							{{ breathBpm }}
						</div>
					</div>
				</div>
				<div class="room-icon-item">
					<div class="item-text item-lin" :class="{ 'metric-hidden': !showRealtimeMetric }">
						<p class="conter-low" :class="{ 'alarm-conter': isShowRedHeart == 1 }"></p>
						<p class="conter"></p>
						<p class="conter-height" :class="{ 'alarm-conter': isShowRedHeart == 3 }"></p>
						<div class="position-cirle" :class="{ 'alarm-conter': isShowRedHeart !== 2 }" :style="{
							left: heartPosition,
							background: isShowRedHeart !== 2 ? '#FF4D4F' : '#5CC726',
						}"></div>
					</div>
					<div class="item-text" :class="{ 'metric-hidden': !showRealtimeMetric }">
						<p :class="{ 'alarm-conter': isShowRedHeart == 1 }">偏低</p>
						<p :style="{
							color: isShowRedHeart == 2 ? '#5CC726' : '#262626',
						}">
							正常
						</p>
						<p :class="{ 'alarm-conter': isShowRedHeart == 3 }">偏高</p>
					</div>
					<div class="img_icon">
						<img v-if="isShowRedHeart == 2" src="./../../../assets/img/heart_green.png" alt="" />
						<img v-else src="./../../../assets/img/heart_alarm@2x.png" alt="" />
						<div class="heart-text" :style="{ color: isShowRedHeart !== 2 ? '#FF4D4F' : '' }" translate="no">
							{{ heartBpm }}
						</div>
					</div>
				</div>
			</div>
		</div>
		<a-modal title="设置" :width="632" :visible="editAbnormalTimePopupOutBed" :maskClosable="false" :footer="null"
			@cancel="$emit('edit-abnormal-time-cancel-out-bed')">
			<div style="display: flex;">
				<div v-if="timePeriods.length > 0">
					<div class="titleTime mb10">监测时间段</div>
					<div class="picker" :key="index" v-for="(item, index) in timePeriods">
						<a-time-picker :allowClear="false" v-model="item.startTime" format="HH:mm"></a-time-picker>
						<img class="rJt" src="../../../assets/rJt.png" alt="">
						<a-time-picker :allowClear="false" v-model="item.endTime" format="HH:mm"></a-time-picker>
					</div>
				</div>
				<div class="picker" style="margin-left: 20px;">
					<div class="titleTime">离床异常时长</div>
					<div style="display: flex; align-items: center; margin-top: 10px;" :key="'out-bed-enable-' + index" v-for="(item, index) in timePeriods">
						<div style="position: relative; margin-right: 10px;">
							<el-switch :value="item.outBedEnable == 0 ? true : false" :width="40" class="switch" active-color="#1890FF"
								inactive-color="rgba(191, 191, 191, 1)" @change="$emit('switch-change-leave-bed-time', item, index)">
							</el-switch>
							<span v-if="item.outBedEnable == 0 ? true : false" class="switch-btn-open" style="position: absolute; left: 7px; color: #FFFFFF; font-size: 12px; top: 3px;">开</span>
							<span v-else class="switch-btn-off" style="position: absolute; right: 7px; color: #FFFFFF; font-size: 12px; top: 3px">关</span>
						</div>
						<a-time-picker :allowClear="false" v-model="item.editHandleTimeValOutBed" format="HH:mm:ss" :style="{opacity: item.outBedEnable == 0 ? 1 : 0.3}" :disabled="item.outBedEnable == 0 ? false : true"></a-time-picker>
					</div>
				</div>
				<div class="leave_phone_alarm">
					<div class="titleTime mb10">离床电话报警</div>
					<div class="leave_phone_alarm-content" :key="index" v-for="(item, index) in timePeriods">
						<el-switch :value="item.outBedPhoneEnable == 0 ? true : false" :width="40" class="switch" active-color="#1890FF" inactive-color="rgba(191, 191, 191, 1)" @change="$emit('switch-change-leave-bed-phone', item, index)"></el-switch>
						<span v-if="item.outBedPhoneEnable == 0 ? true : false" class="switch-btn-open" style="position: absolute; left: 7px; color: #FFFFFF; font-size: 12px; top: 7px;">开</span>
						<span v-else class="switch-btn-off" style="position: absolute; right: 51px; color: #FFFFFF; font-size: 12px; top: 7px">关</span>
					</div>
				</div>
			</div>
			<div style="display: flex; align-items: center; margin-top: 10px; margin-bottom: 20px;">
				<div style="font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: #58595A; line-height: 20px;">呼吸过速报警阈值</div>
				<a-select
					v-if="alarmModel"
					placeholder="请选择"
					:default-value="alarmModel.breathFast"
					option-filter-prop="children"
					style="width: 99px; margin-left: 10px; margin-right: 10px;"
					:filter-option="filterOptionFn"
					@focus="$emit('handle-focus')"
					@blur="$emit('handle-blur')"
					@change="$emit('handle-change', $event)"
				>
					<a-select-option :value="item" :key="index" v-for="(item, index) in [27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40]">
					{{ item }}
					</a-select-option>
				</a-select>
				<div style="font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: #58595A; line-height: 20px;">bpm</div>
			</div>
			<div class="picker">
				<div class="titleTime">关联卫生间</div>
				<a-cascader :value="relateWC_treeData_value_Sel_Next" :default-value="relateWC_treeData_value"
					:options="relateWC_treeData" placeholder="点击选择需要关联的设备" @change="$emit('change-relate-wc', $event)" />
			</div>
			<div class="addBtn toitet-btn">
				<a-button style="margin-right: 10px" @click="$emit('edit-abnormal-time-cancel-out-bed')">取消</a-button>
				<a-button type="primary" @click="$emit('edit-abnormal-time-toitet-new-new')">确定</a-button>
			</div>
		</a-modal>
		<a-modal title="温馨提示" :width="400" :visible="isShowTipAlertWqsn" :maskClosable="false" :footer="null"
			@cancel="$emit('tip-alert-click-cancel-wqsn')">
			<div style="display: block; align-items: center; margin-top: 10px; margin-bottom: 20px;">
				<img style="width: 16px; height: 16px; display: inline; margin-right: 5px; margin-top: -2px;" src="./../../../assets/icon_alert_warning.png" alt="" />
				<div style="font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: #58595A; line-height: 20px; display: inline;">当前建议的阈值是最适合“完全失能”老人的设置，修改之后可能会影响监测效果，请慎重考虑，确定要修改吗？</div>
			</div>
			<div class="addBtn toitet-btn" style="margin-left: 210px;">
				<a-button style="margin-right: 10px" @click="$emit('tip-alert-click-cancel-wqsn')">取消</a-button>
				<a-button type="primary" @click="$emit('tip-alert-click-sure-wqsn')">确定</a-button>
			</div>
		</a-modal>
	</div>
</template>

<script>
export default {
	name: 'RoomRightPanel',
	props: {
		isShowGray: {
			type: Number,
			default: 1,
		},
		role: {
			type: [Number, String],
			default: 2,
		},
		switchStatus: {
			type: Boolean,
			default: false,
		},
		roomStatus: {
			type: Number,
			default: 1,
		},
		isShowRedBreath: {
			type: Number,
			default: 2,
		},
		isShowRedHeart: {
			type: Number,
			default: 2,
		},
		breathPosition: {
			type: String,
			default: '0%',
		},
		heartPosition: {
			type: String,
			default: '0%',
		},
		breathBpm: {
			type: [Number, String],
			default: '--',
		},
		heartBpm: {
			type: [Number, String],
			default: '--',
		},
		editAbnormalTimePopupOutBed: {
			type: Boolean,
			default: false,
		},
		getFallLongTimeData: {
			type: [Object, String],
			default: () => ({ timePeriods: [] }),
		},
		alarmModel: {
			type: Object,
			default: null,
		},
		relateWC_treeData: {
			type: Array,
			default: () => [],
		},
		relateWC_treeData_value: {
			type: Array,
			default: () => [],
		},
		relateWC_treeData_value_Sel_Next: {
			type: Array,
			default: () => [],
		},
		isShowTipAlertWqsn: {
			type: Boolean,
			default: false,
		},
		filterOptionFn: {
			type: Function,
			default: () => false,
		},
	},
	computed: {
		isReadonlyRole() {
			return String(this.role) === '3';
		},
		showRealtimeMetric() {
			return this.roomStatus == 1 || this.roomStatus == 5 || this.roomStatus == 6;
		},
		timePeriods() {
			const periods = this.getFallLongTimeData && this.getFallLongTimeData.timePeriods;
			return Array.isArray(periods) ? periods : [];
		},
		localSwitchStatus: {
			get() {
				return this.switchStatus;
			},
			set(val) {
				this.$emit('update:switchStatus', val);
			},
		},
	},
	methods: {
		emitSetStatus() {
			this.$emit('set-status');
		},
	},
};
</script>

<style lang="scss" scoped>
.picker {
	padding-bottom: 10px;

	.titleTime {
		margin-right: 10px;
		margin-bottom: 10px;
	}

	.rJt {
		width: 14px;
		height: 7px;
		margin-left: 5px;
		margin-right: 5px;
	}
}

.toitet-btn {
	margin-top: 20px;
	display: flex;
	justify-content: flex-end;
}

::v-deep .ant-modal-body {
	background: #fff;
}

::v-deep .ant-cascader-picker {
	width: 100%;
}

.room-right {
	p {
		margin-bottom: 0em;;
	}
	background-image: -webkit-gradient(linear,
			left top,
			right top,
			from(#bfbfbf),
			color-stop(50%, #bfbfbf),
			color-stop(50%, transparent));
	background-image: linear-gradient(to bottom,
			#bfbfbf 50%,
			#bfbfbf 0%,
			transparent 50%);
	background-size: 1px 10px;
	background-repeat: repeat-y;
	margin-bottom: 15px;

	.room-right-con {
		display: flex;
		flex-direction: column;
		height: 100%;
	}

	.switch {
		margin-left: 10px;

		.realTop_left {
			width: 330px;
			padding-top: 10px;
			padding-bottom: 25px;

			.left_header {
				display: flex;
				justify-content: flex-start;
				align-items: center;

				.left_title {
					font-size: 18px;
					font-weight: 400;
					color: #262626;
				}

				.switch-btn-open {
					font-size: 12px;
					color: #ffffff;
					position: absolute;
					top: 3px;
					left: 17px;
				}

				.switch-btn-off {
					font-size: 12px;
					color: #ffffff;
					position: absolute;
					top: 3px;
					left: 32px;
				}

				.title-flex {
					flex: 1;
					display: flex;
					align-items: center;
					justify-content: space-between;

					.title-flex-set {
						color: #1890ff;
						cursor: pointer;
						font-size: 14px;
					}
				}
			}
		}
	}

	.room-icon {
		display: flex;
		align-items: center;
		justify-content: space-around;
		flex-direction: column;
		flex: 1;

		.room-icon-item {
			width: 100%;
			display: flex;
			flex-direction: column;
			align-items: center;

			.item-text {
				display: flex;
				align-items: center;
				justify-content: space-around;
				width: 100%;
				transition: opacity 0.2s ease;

				.alarm-conter {
					color: #ff4d4f;
				}
			}

			.metric-hidden {
				opacity: 0;
				pointer-events: none;
			}

			.item-lin {
				display: flex;
				justify-content: space-between;
				padding: 0 20px 0 10px;
				position: relative;
				margin-bottom: 12px;

				.conter-low {
					width: 80px;
					background: #bfbfbf;
					height: 5px;
				}

				.conter {
					flex: 1;
					background: #d9f7be;
					height: 5px;
				}

				.conter-height {
					width: 80px;
					background: #bfbfbf;
					height: 5px;
				}

				.alarm-conter {
					background: #ff9899;
				}

				.position-cirle {
					width: 20px;
					height: 20px;
					background: #5cc726;
					box-shadow: 0px 0px 2px 0px rgba(172, 172, 172, 0.5);
					border: 2px solid #e9ffde;
					border-radius: 50%;
					position: absolute;
					top: -8px;
					left: 0;
				}
			}
		}

		.img_icon {
			display: flex;
			font-size: 68px;
			line-height: 68px;
			color: #bfbfbf;
			align-items: center;
			justify-content: space-around;
			width: 180px;
			font-weight: 200;

			.breath-text {
				color: #1890ff;
			}

			.heart-text {
				color: #53c31b;
			}
		}

		img {
			width: 68px;
			height: 58px;
		}
	}
}

.leave_phone_alarm {
	margin-left: 20px;
	display: flex;
	flex-direction: column;

	.leave_phone_alarm-content {
		flex: 1;
		padding-top: 4px;
		position: relative;
	}
}
</style>
